import { EmployeeDto } from "./employee.dto";
import { EmployeeBandDto } from "./employee-band.dto";
import { EmployeeLoanBenefit } from "./employee-loan-benefit.dto";
import { EmployeeBandLoanBenefit } from "./employee-band-loan-benefit.dto";
import { PaginatorInfo } from "./generic.dto";

export type LoanBenefit = {
  id: number;
  companyId: number;
  code: string;
  name: string;
  description: string | null;
  centralBankInterestRate: number;
  employerInterestRate: number;
  loanTenor: number;
  floor: number | null;
  ceiling: number | null;
  groupId: number | null;
  createdAt: Date;
  modifiedAt: Date | null;
}

export class CreateLoanBenefitDto {
  companyId!: number
  code!: string
  name!: string
  description?: string
  centralBankInterestRate!: number
  employerInterestRate!: number
  loanTenor!: number
  floor?: number
  ceiling?: number
  employeeIds?: number[]
  employeeBandIds?: number[]
  groupId?: number
}

export class UpdateLoanBenefitDto {
  code?: string
  name?: string
  description?: string
  centralBankInterestRate?: number
  employerInterestRate?: number
  loanTenor?: number
  floor?: number
  ceiling?: number
  addEmployeeIds?: number[];
  removeEmployeeIds?: number[];
  addEmployeeBandIds?: number[];
  removeEmployeeBandIds?: number[];
  groupId?: number
}

export interface LoanBenefitDto extends LoanBenefit {
  employeeLoanBenefits?: EmployeeLoanBenefitDto[];
  employeeBandLoanBenefits?: EmployeeBandLoanBenefitDto[];
  group?: LoanBenefitDto;
}

export interface EmployeeLoanBenefitDto extends EmployeeLoanBenefit {
  employee?: EmployeeDto;
}

export interface EmployeeBandLoanBenefitDto extends EmployeeBandLoanBenefit {
  employeeBand?: EmployeeBandDto;
}

export interface LoanBenefitPaginator extends PaginatorInfo<LoanBenefitDto> {}

export class QueryLoanBenefitDto {
  companyId?: number;
  code?: string;
  groupId?: number;
  page: number = 1;
  limit?: number;
  orderBy: LoanBenefitOrderBy = LoanBenefitOrderBy.CREATED_AT_ASC;
}


export class SearchLoanBenefitDto {
  q?: string;
  companyId?: number;
  page: number = 1;
  limit?: number;
  orderBy: LoanBenefitOrderBy = LoanBenefitOrderBy.CREATED_AT_ASC;
}


export enum LoanBenefitOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
  CODE_ASC = 'code:asc',
  CODE_DESC = 'code:desc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc'
}

export class ExportLoanBenefitQueryDto {
  loanBenefitCode?: boolean;
  loanBenefitName?: boolean;
  description?: boolean;
  centralBankInterestRate?: boolean;
  employerInterestRate?: boolean;
  loanTenor?: boolean;
  floor?: boolean;
  ceiling?: boolean;
  groupCode?: boolean;
  orderBy: LoanBenefitOrderBy = LoanBenefitOrderBy.CREATED_AT_ASC;
}

export class UploadLoanBenefitsResponse {
  successful!: {
    loanBenefitId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}